export default {
  journeys: state => state.journeys,
  journey: state => state.journey,
  loading: state => state.loading,
  hasJourneys: state => state.journeys && state.journeys.length > 0,
}
